<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <div
      class="navbar nav-main w-100"
      style="background-color:#23409A;color:white"
    >
      <h3 class="w-100 text-center my-3">เปลี่ยนแปลงเบอร์โทรศัพท์</h3>
    </div>
    <div class="mb-2 flex-all-center session-with-nav">
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width:170px;height:auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
    </div>
    <div class="pa-6">
      <div style="color: 817F7F;" class="mb-5">กรุณากรอกเบอร์โทรศัพท์ใหม่</div>
      <ValidationObserver ref="observer">
        <ValidationProvider
          rules="required|thai_phonenumber"
          name="เบอร์โทรศัพท์"
          v-slot="{ errors }"
        >
          <custom-input
            :maxlength="10"
            type="tel"
            v-model="input.phone"
            :placeholder="'เบอร์โทรศัพท์'"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
      </ValidationObserver>
    </div>
    <div class="flex-all-center mt-2">
      <v-btn
        :loading="loading"
        @click="nextOTP"
        class="col-8 main-btn"
        style="color:white;"
        color="#23409a"
        >ถัดไป</v-btn
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import CustomInput from "../CustomInput.vue";
import { extend } from "vee-validate";

extend("thai_phonenumber", {
  message: "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
  validate: (value) => {
    var pattern = new RegExp(/^[0][3-9][0-9]{4}[0-9]{4}$/); // fragment locator
    return pattern.test(value);
  },
});

export default {
  components: { CustomInput },
  data() {
    return {
      loading: false,
      loadingFull: false,
    };
  },
  methods: {
    async nextOTP() {
      let IsValid = await this.$refs.observer.validate();
      if (IsValid) {
        this.loading = true;
        // Get api to generate otp
        let type = this.$store.state.changePhoneMethod;
        let result = null;
        let data = null;
        if (type == "sync") {
          data = {
            LineUserId: this.userId || this.$store.state.query.userId,
            PhoneNumber: this.input.phone,
            pageid: config.pageid,
          };
          result = await api.regisedSendOtp(data);
          this.loading = false;
        } else {
          data = {
            idCard: this.authData.idcard,
            dob: this.authData.dob,
            nextCardId: this.authData.nextcard,
            phoneNumber: this.input.phone,
            pageid: config.pageid,
          };
          result = await api.SendOtpWithAuth(data);
        }

        this.loading = false;
        if (result.responsecode == 200) {
          this.$store.state.ref = result.data;
          this.$emit("next");
        } else if (result.responsecode == 300) {
          this.$swal.fire({
            type: "error",
            text: "ไม่มีข้อมูลในระบบ",
          });
        } else {
          this.$swal.fire({
            type: "error",
            text: "เกิดข้อผิดพลาด",
          });
        }
      }
    },
  },
  computed: {
    userId() {
      return this.$store.state.profile.userId;
    },
    input() {
      return this.$store.state.changePhoneObj;
    },
    authData() {
      return this.$store.state.formatAuthorizeData;
    },
  },
};
</script>
